import vscDarkPlus from "react-syntax-highlighter/dist/esm/styles/prism/vsc-dark-plus";

// Dark theme without background - override the theme's background to be transparent
export const DARK_THEME_NO_BACKGROUND = {
  ...vscDarkPlus,
  'pre[class*="language-"]': {
    ...vscDarkPlus['pre[class*="language-"]'],
    background: "transparent",
  },
  'code[class*="language-"]': {
    ...vscDarkPlus['code[class*="language-"]'],
    background: "transparent",
  },
} as const;

export const CUSTOM_STYLE = {
  margin: "0px",
  width: "fit-content",
  padding: "0",
  backgroundColor: "none",
  height: "100%",
} as const;

export const SENTIMENTS_COLORS = {
  positive: {
    border: "border-success-light dark:border-success-main",
    background: "bg-success-lightest dark:bg-success-dark",
  },
  negative: {
    border: "border-error-light dark:border-error-main",
    background: "bg-error-lightest dark:bg-error-dark",
  },
  neutral: {
    border: "border-neutral-light dark:border-neutral-dark",
    background: "bg-neutral-lightest dark:bg-neutral-dark",
  },
} as const;
